import type { LoginRequest } from '@contracts/auth'
import type { Session } from './session-model'

export type { LoginRequest, Session }

export interface AuthProvider {
  /** Current session, or `null` when not signed in. */
  getSession(): Promise<Session | null>
  /** Rejects with an InvalidCredentialsError for a wrong e-mail address or password. */
  login(credentials: LoginRequest): Promise<Session>
  /** Always ends the session in the browser, also when the backend cannot be reached. */
  logout(): Promise<void>
  /** Fires when the session ended because the backend no longer renews it. */
  onExpired(listener: () => void): () => void
}

export class InvalidCredentialsError extends Error {
  override readonly name = 'InvalidCredentialsError'
}
